export const Services = {
   "AUDIT": {
      "path": "https://rrapiauditoria.azurewebsites.net/",
      "method": "",
      "descrp": "AUDIT"
   }
}